var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityFilled = function SvgSecurityFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.714 1.089a2 2 0 0 1 .572 0c.219.032.422.108.584.17l.043.016 5.493 2.06c.617.23 1.16.432 1.578.8a3 3 0 0 1 .82 1.184c.198.52.197 1.1.196 1.76V12c0 2.827-1.537 5.184-3.199 6.915-1.673 1.743-3.587 2.974-4.599 3.564l-.04.024a2.4 2.4 0 0 1-.742.317c-.26.056-.58.056-.84 0a2.4 2.4 0 0 1-.74-.317l-.042-.024c-1.012-.59-2.926-1.821-4.599-3.564C4.538 17.184 3 14.827 3 12V7.078c0-.659-.002-1.238.196-1.759a3 3 0 0 1 .82-1.183c.419-.369.961-.571 1.579-.802l5.492-2.06.044-.016c.161-.06.365-.137.583-.17m4.493 8.619a1 1 0 0 0-1.414-1.415L11 12.086l-1.293-1.293a1 1 0 0 0-1.414 1.415l2 2a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
export default SvgSecurityFilled;